const translations = {
  FAMILY_MODAL_REMOVE_FAMILY: {
    description: 'Family member remove text',
    primaryValue: 'Remove Family Member',
    stringKey: 'FAMILY_MODAL_REMOVE_FAMILY',
  },
  CANCEL_FAMILY_MODAL_INFORM: {
    description: 'Family member cancel text',
    primaryValue: 'Be sure to inform your family member',
    stringKey: 'CANCEL_FAMILY_MODAL_INFORM',
  },
  CANCEL_FAMILY_MODAL_KEEP: {
    description: 'Family member keep text',
    primaryValue: 'Keep',
    stringKey: 'CANCEL_FAMILY_MODAL_KEEP',
  },
  CANCEL_FAMILY_MODAL_REMOVE: {
    description: 'Family member remove text',
    primaryValue: 'Remove',
    stringKey: 'CANCEL_FAMILY_MODAL_REMOVE',
  },
};

export { translations };
